module.exports = __webpack_public_path__ + "static/img/login7.ebb205df.png";